import { container } from "tsyringe";
export class UseCasePaidOfDestinationOrder {
    async handle(order) {
        const createOrdeService = container.resolve("iCreateOrdeService");
        // create the order
        let orderResult = await createOrdeService.handle(order);
        return orderResult;
    }
}
